import { render, staticRenderFns } from "./CreateAccessory.vue?vue&type=template&id=1fbef562&scoped=true"
import script from "./CreateAccessory.vue?vue&type=script&lang=ts"
export * from "./CreateAccessory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbef562",
  null
  
)

export default component.exports